import React, { FunctionComponent, useEffect, useState } from 'react';
import { useStore } from '@hooks';
import { observer } from 'mobx-react-lite';
import { getApiUrl } from '../../helpers/get-api-url';

const ProvModule: FunctionComponent<{}> = observer((): JSX.Element => {
    const { userStore } = useStore();

    const [height, setHeight] = useState(600);

    const [url, setUrl] = useState<string>('');

    useEffect(() => {
        if (userStore.token) {
            const fun = async () => {
                const requestUrl = getApiUrl(window.env.REACT_APP_HTTP_URL);

                const resp = await fetch(`${requestUrl}/provider/1/getUrl`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${userStore.token}`,
                    },
                }).then((response) => response.json());

                if (resp && resp.url) setUrl(resp.url);
                setHeight(680);
            };
            fun();
        }
    }, [userStore, userStore.token]);

    return (
        <iframe width="100%" height={height} src={url} title={'Plinko game!'}>
            Hey!
        </iframe>
    );
});

export default ProvModule;